const env = process.env.REACT_APP_ISV_ENV || 'default';

const config = require(`./env.config.${env}.js`).default;

export default config;
